export default "__VITE_ASSET__DMdUY53Y__"